import axios from "axios";

const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

const authHeaders = () => ({
  "Content-Type": "application/json",
  "x-access-token": `${localStorage.getItem("token") || ""}`
});

export const ProgramOptions = async () => {
  const programList = await axios.post(
    `${apiBaseURL}/api/v1/admin/getprogramsoptions`,
    { searchBy: "" },
    {
      headers: authHeaders()
    }
  );
  if (programList.data) {
    const { allPrograms } = programList.data.data;
    const allprograms = allPrograms.map((value) => {
      return {
        id: value?._id,
        name: `${value?.name}`,
        days: +value.days,
        restDays: value.restDays,
        addedDays: value.addedDays
      };
    });
    return allprograms;
  }
};

export const ExerciseOptions = async () => {
  const exerciseList = await axios.post(
    `${apiBaseURL}/api/v1/admin/getexerciseoptions`,
    { searchBy: "" },
    {
      headers: authHeaders()
    }
  );
  if (exerciseList.data) {
    const { exercises } = exerciseList.data.data;
    const allExercise = exercises.map((value) => {
      return {
        id: value?._id,
        name: `${value?.name}`
      };
    });
    return allExercise;
  }
};
